import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'

export const Route = createFileRoute('/_app/commissions/plans')({
  staticData: { crumb: 'commissionPlans' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'commissions.read'),
  component: Outlet,
})
